import { Pipe, PipeTransform } from '@angular/core';
import { ItemForDisplay } from '../../models';

@Pipe({
  name: 'productActionButtonLabel',
  standalone: true,
  pure: true
})
export class ProductActionButtonLabelPipe implements PipeTransform {
  transform(item: ItemForDisplay, isRental: boolean): string {
    if (item.HidePrice) {
      return 'CALL FOR PRICE';
    }
    return isRental ? 'RENT' : '';
  }
}
